"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IndicatorComponent = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  background-color: ", ";\n  height: ", ";\n  width: ", ";\n  border-radius: ", ";\n  margin: ", ";\n"])), function (props) {
  return props.bgColor;
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, function (props) {
  return props.rounded;
}, function (props) {
  return props.margin;
});

function Indicator(props) {
  var bgColor = props.bgColor,
      height = props.height,
      width = props.width,
      margin = props.margin,
      className = props.className;
  return /*#__PURE__*/_react.default.createElement(IndicatorComponent, {
    bgColor: bgColor,
    height: height,
    width: width,
    rounded: width,
    margin: margin,
    className: className
  });
}

var _default = Indicator;
exports.default = _default;